"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserAvatar = exports.ProfileAndLogout = exports.Profile = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject, _templateObject2, _templateObject3;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ProfileAndLogout = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n"])));

exports.ProfileAndLogout = ProfileAndLogout;

var Profile = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: .3rem;\n"])));

exports.Profile = Profile;

var UserAvatar = _styledComponents.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  width: 2rem;\n  height: 2rem;\n  object-fit: cover;\n  border-radius: 50%;\n\n  @media (min-width: 481px) {\n    width: 2.5rem;\n  }\n"])));

exports.UserAvatar = UserAvatar;